import { render, staticRenderFns } from "./statistics-breakdown-summary-data-point.vue?vue&type=template&id=c25f6eec"
import script from "./statistics-breakdown-summary-data-point.vue?vue&type=script&lang=js"
export * from "./statistics-breakdown-summary-data-point.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports